module.exports = __webpack_public_path__ + "img/标题矩形-激活.d87935d6.png";